export default __webpack_public_path__ + "static/media/glueckliche_kinobesucher_warten_auf_kinoprogramm.df33ba23.jpg";